import React from 'react';
import { useLocation } from '@reach/router';
import LeadGenerationOpenForm from '@components/LeadGenerationForm/LeadGenerationOpenForm';

const PROGRAM_TITLES = {
  'full-stack': 'Gen-AI Powered Fullstack Program',
  'data-analytics': 'Gen-AI Powered Data Analytics & Data Science Program',
  'qa-automation': 'Gen-AI Powered QA Automation Program',
  default: 'AI-Enabled Skill Advancement Program',
};

const AiSkillDevelopmentPageHero = ({ buttonText }) => {
  const { pathname } = useLocation();

  const getProgramTitle = (path) => {
    if (path.includes('full-stack')) return PROGRAM_TITLES['full-stack'];
    if (path.includes('qa-automation')) return PROGRAM_TITLES['qa-automation'];
    if (path.includes('data-analytics'))
      return PROGRAM_TITLES['data-analytics'];
    return PROGRAM_TITLES.default;
  };

  const programTitle = getProgramTitle(pathname);

  return (
    <section className="flex w-full flex-col items-center pb-8 pt-12 font-manrope md:pt-32 md:pb-16">
      <div className="container mx-auto flex flex-col items-center justify-between gap-12 px-4 md:flex-row md:gap-0">
        {/* Left: Text Content */}
        <div className="w-full max-w-2xl flex-1 text-center md:text-left">
          <h1 className="mb-2 text-xl font-bold leading-tight text-black md:mb-6 md:text-4xl">
            Crio SkillQ
          </h1>
          <h2 className="mb-6 text-2xl font-bold leading-tight text-black md:mb-12 md:text-5xl">
            {programTitle}
          </h2>
          <p className="mb-6 text-base font-medium text-v5-neutral-400 md:items-center md:text-2xl">
            <span className="block w-full font-bold md:inline">
              The New Metric That Matters —
            </span>
            <span className="block md:inline">
              <span className="font-bold">SkillQ</span>
              <span className="mx-2 font-bold">≫</span>
              <span className="font-bold">IQ | EQ</span>
            </span>
          </p>
          <p className="mb-6 text-[10px] font-medium text-v5-neutral-400 md:text-base">
            It's not just IQ or EQ that gets you hired — it's your{' '}
            <span className="font-bold">
              Skill Quotient, <br /> Supercharged with AI{' '}
            </span>{' '}
            defining your ability to:
          </p>
          <div className="mb-8 flex flex-row justify-center gap-4 overflow-x-auto text-[10px] text-v5-neutral-400 md:flex-wrap md:justify-start md:text-base">
            {[
              'Apply Real Skills',
              'Solve Real Problems',
              'Deliver Real Impact',
            ].map((item, i) => (
              <span
                key={i}
                className="whitespace-nowrap rounded-md bg-[#E6F4F2] px-6 py-2 font-semibold shadow-sm"
              >
                {item}
              </span>
            ))}
          </div>
        </div>

        {/* Right: Form */}
        <div className="mb-8 flex w-full max-w-md flex-1 items-center justify-center md:mb-0">
          <div className="flex w-full items-center">
            <LeadGenerationOpenForm
              wrapperClassName="flex justify-center"
              pageOneButtonText={buttonText}
              pageTwoButtonText={buttonText}
              hasProgramInterestedField
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiSkillDevelopmentPageHero;
